function showSuccessMessage() {
    $(".submit-before").addClass("hidden");
    $(".submit-after").removeClass("hidden");
    $(".pageWrapper .section-content").hide();
}
export default showSuccessMessage;
